import React, { createContext, useEffect } from 'react';
import axios from 'src/utils/axios';
import { API_PATH } from 'src/config-global';
import {
  ApiContextType,
  UserRegisterType,
  UserLoginType,
} from 'src/types';
import { useDispatch } from 'src/store';
import { edit } from 'src/store/reducers/auth';

const ApiContext = createContext<ApiContextType | null>(null);
/* eslint-disable */
export const ApiProvider = ({ children }: { children: React.ReactElement }) => {
  const dispatch = useDispatch();

  const initialize = async () => {
    const response = await axios.post(API_PATH.AUTH_CHECK);
    return dispatch(edit(!response ? {} : response.data));
  };

  useEffect(() => {
    initialize();
  }, []);

  const register = async (data: UserRegisterType) => {
    return await axios.post(API_PATH.AUTH_REGISTER, data);
  };

  const login = async (data: UserLoginType) => {
    return await axios.post(API_PATH.AUTH_LOGIN, data);
  };

  return (
    <ApiContext.Provider
      value={{
        // initialize,
        register,
        login,
      }}
    >
      {children}
    </ApiContext.Provider>
  );
};

export default ApiContext;
